function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  ).filter((element) => {
    if (!element) return false;
    if (element.hidden) return false;
    if (element.getAttribute("aria-hidden") === "true") return false;
    if (element.closest("[hidden], [aria-hidden='true']")) return false;

    const computedStyle = window.getComputedStyle(element);
    if (computedStyle.display === "none" || computedStyle.visibility === "hidden") {
      return false;
    }

    return element.offsetParent !== null;
  });
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  const isHeaderDrawerSummary = Boolean(summary.closest("header-drawer"));

  // The header drawer summaries are left as native <summary> elements. They were given
  // role="button" without aria-expanded, so assistive technology announced a button with
  // no expanded or collapsed state. Native disclosure semantics convey that on their own.
  if (!isHeaderDrawerSummary) {
    summary.setAttribute("role", "button");
    summary.setAttribute(
      "aria-expanded",
      summary.parentNode.hasAttribute("open")
    );

    if (summary.nextElementSibling.getAttribute("id")) {
      summary.setAttribute("aria-controls", summary.nextElementSibling.id);
    }

    summary.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });
  }

  if (isHeaderDrawerSummary) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && !container.contains(event.target)) return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key

    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    if (!first || !last) return;

    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);

    if (this.input.min) {
        const min = parseInt(this.input.min);
        const buttonMinus = this.querySelector(".quantity__button[name='minus']");
        const isMinusDisabled = value <= min;

        buttonMinus.classList.toggle("disabled", isMinusDisabled);
        if (isMinusDisabled) {
          buttonMinus.setAttribute("tabindex", "-1");
          buttonMinus.setAttribute("aria-disabled", "true");
          buttonMinus.setAttribute("disabled", "disabled");
        } else {
          buttonMinus.removeAttribute("tabindex");
          buttonMinus.removeAttribute("aria-disabled");
          buttonMinus.removeAttribute("disabled");
        }
    }

    if (this.input.max) {
        const max = parseInt(this.input.max);
        const buttonPlus = this.querySelector(".quantity__button[name='plus']");
        const isPlusDisabled = value >= max;

        buttonPlus.classList.toggle("disabled", isPlusDisabled);
        if (isPlusDisabled) {
          buttonPlus.setAttribute("tabindex", "-1");
          buttonPlus.setAttribute("aria-disabled", "true");
          buttonPlus.setAttribute("disabled", "disabled");
        } else {
          buttonPlus.removeAttribute("tabindex");
          buttonPlus.removeAttribute("aria-disabled");
          buttonPlus.removeAttribute("disabled");
        }
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");
    this.normalizeSubmenuSummarySemantics();

    // Store which category accordions should be open by default (based on active URL)
    this.defaultOpenAccordions = new Set();
    const mobileFacetsInner = this.querySelector('.mobile-facets__inner');
    if (mobileFacetsInner) {
      mobileFacetsInner.querySelectorAll('webi-collapse details[open]').forEach((details) => {
        if (details.id) {
          this.defaultOpenAccordions.add(details.id);
        }
      });
    }

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  normalizeSubmenuSummarySemantics() {
    const summaries = this.querySelectorAll(
      ".menu-item-with-dropdown > details > summary"
    );

    summaries.forEach((summary) => {
      const parentLink = summary.querySelector(":scope > a.menu-drawer__menu-item");
      if (!parentLink) return;
      const parentHref = parentLink.getAttribute("href");

      if (parentHref && parentHref !== "#") {
        summary.dataset.parentHref = parentHref;
      }

      const summaryLabel = document.createElement("span");
      summaryLabel.className = `${parentLink.className} menu-drawer__summary-label`;
      summaryLabel.innerHTML = parentLink.innerHTML;
      parentLink.replaceWith(summaryLabel);
    });
  }

  isSummaryToggleArea(summaryElement, event) {
    if (!(event instanceof MouseEvent)) return true;

    const target = event.target;
    if (
      target instanceof Element &&
      target.closest(".icon-arrow, .icon-caret")
    ) {
      return true;
    }

    const rect = summaryElement.getBoundingClientRect();
    const toggleZoneWidth = 64;
    return event.clientX >= rect.right - toggleZoneWidth;
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button:not(.localization-selector)").forEach(
      (button) =>
        button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const parentHref = summaryElement.dataset.parentHref;
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 992px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      if (parentHref && !this.isSummaryToggleArea(summaryElement, event)) {
        event.preventDefault();
        window.location.assign(parentHref);
        return;
      }

      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);

    // Restore only the category accordions that should be open by default
    const mobileFacetsInner = this.querySelector('.mobile-facets__inner');
    if (mobileFacetsInner && this.defaultOpenAccordions.size > 0) {
      mobileFacetsInner.querySelectorAll('webi-collapse details').forEach((details) => {
        const toggle = details.querySelector('.toggle');
        const content = details.querySelector('.wbcollapse_cont');

        if (toggle && content) {
          // Check if this accordion should be open by default
          const shouldBeOpen = details.id && this.defaultOpenAccordions.has(details.id);

          if (shouldBeOpen) {
            // Open this accordion
            details.setAttribute('open', '');
            toggle.classList.add('active');
            toggle.classList.remove('collapsed');
            toggle.setAttribute('aria-expanded', 'true');
            content.style.height = null;
            content.style.visibility = 'visible';
            content.setAttribute('data-collapsed', 'false');
          } else {
            // Ensure it's closed
            details.removeAttribute('open');
            toggle.classList.remove('active');
            toggle.classList.add('collapsed');
            toggle.setAttribute('aria-expanded', 'false');
            content.style.height = '0px';
            content.style.visibility = 'hidden';
            content.setAttribute('data-collapsed', 'true');
          }
        }
      });
    }
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });

    // Reset all WebiCollapse accordions internal state
    const mobileFacetsInner = this.querySelector('.mobile-facets__inner');
    if (mobileFacetsInner) {
      mobileFacetsInner.querySelectorAll('webi-collapse details').forEach((details) => {
        const toggle = details.querySelector('.toggle');
        const content = details.querySelector('.wbcollapse_cont');
        if (toggle && content) {
          toggle.classList.remove('active');
          toggle.classList.add('collapsed');
          toggle.setAttribute('aria-expanded', 'false');
          content.style.height = '0px';
          content.style.visibility = 'hidden';
          content.setAttribute('data-collapsed', 'true');
        }
      });
    }

    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle &&
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
    const internalClose = this.querySelector('.menu-drawer__close-btn-internal');
    if (internalClose) {
      internalClose.addEventListener('click', () => {
        this.closeMenuDrawer(
          { type: 'click' },
          this.mainDetailsToggle.querySelector('summary')
        );
      });
    }
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    const drawerInternalClose = this.mainDetailsToggle.querySelector('.menu-drawer__close-btn-internal');
    trapFocus(this.mainDetailsToggle, drawerInternalClose || summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    document.body.classList.add(`menu-overflow-remove`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
    window.removeEventListener("resize", this.onResize);
    const mainSummary = this.mainDetailsToggle && this.mainDetailsToggle.querySelector('summary');
    if (mainSummary) mainSummary.setAttribute('aria-expanded', 'false');
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset
        )}px`
      );
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );
  };
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.onKeyUp = this.onKeyUp.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.escapeHandledByPhotoSwipe = false;
    this.closeButton = this.querySelector('[id^="ModalClose-"]');
    if (this.closeButton) {
      this.closeButton.addEventListener("click", this.hide.bind(this, false));
    }
    this.addEventListener("keyup", this.onKeyUp);
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  onKeyDown(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;
    if (!this.hasAttribute("open")) return;

    const eventTarget = event.target;
    const targetInsidePhotoSwipe = eventTarget instanceof Element && eventTarget.closest(".pswp");
    const openPhotoSwipe = document.querySelector(".pswp.pswp--open");

    if (targetInsidePhotoSwipe || openPhotoSwipe) {
      this.escapeHandledByPhotoSwipe = true;
    }
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;
    if (!this.hasAttribute("open")) return;

    if (this.escapeHandledByPhotoSwipe) {
      this.escapeHandledByPhotoSwipe = false;
      return;
    }

    const eventTarget = event.target;
    if (eventTarget instanceof Element && eventTarget.closest(".pswp")) return;

    // If PhotoSwipe is open, let Escape close only PhotoSwipe first.
    const openPhotoSwipe = document.querySelector(".pswp.pswp--open");
    if (openPhotoSwipe) return;

    this.hide();
  }

  getFirstFocusableElement(container) {
    return getFocusableElements(container).find((element) => {
      const style = window.getComputedStyle(element);
      return (
        !element.hasAttribute("disabled") &&
        element.getAttribute("tabindex") !== "-1" &&
        style.display !== "none" &&
        style.visibility !== "hidden" &&
        element.getClientRects().length > 0
      );
    });
  }

  show(opener) {
    this.previouslyFocusedElement = document.activeElement;
    this.openedBy = opener || this.previouslyFocusedElement;
    const popup = this.querySelector(".template-popup");
    const dialog = this.querySelector('[role="dialog"]') || this;

    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    document.addEventListener("keydown", this.onKeyDown, true);
    document.addEventListener("keyup", this.onKeyUp);

    requestAnimationFrame(() => {
      const focusTarget = this.getFirstFocusableElement(dialog) || dialog;
      trapFocus(dialog, focusTarget);

      // Some quick-add contexts restore focus to the trigger after render; enforce in-dialog focus.
      if (!dialog.contains(document.activeElement)) {
        focusTarget.focus();
      }

      if (!dialog.contains(document.activeElement)) {
        dialog.focus();
      }

      // Reinforce once more after paint to handle late focus shifts from async quick-add rendering.
      window.setTimeout(() => {
        if (!this.hasAttribute("open")) return;
        if (dialog.contains(document.activeElement)) return;

        const delayedFocusTarget = this.getFirstFocusableElement(dialog) || dialog;
        delayedFocusTarget.focus();

        if (!dialog.contains(document.activeElement)) {
          dialog.focus();
        }
      }, 80);
    });

    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    this.escapeHandledByPhotoSwipe = false;
    document.removeEventListener("keydown", this.onKeyDown, true);
    document.removeEventListener("keyup", this.onKeyUp);

    const focusReturnTarget =
      (this.openedBy && this.openedBy.isConnected && typeof this.openedBy.focus === "function" && this.openedBy) ||
      (this.previouslyFocusedElement &&
        this.previouslyFocusedElement.isConnected &&
        typeof this.previouslyFocusedElement.focus === "function" &&
        this.previouslyFocusedElement) ||
      null;

    removeTrapFocus(focusReturnTarget);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    const isAtStart =
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0;
    const isAtEnd = this.isSlideVisible(
      this.sliderItemsToShow[this.sliderItemsToShow.length - 1],
      -1
    );

    this.updateControlState(this.prevButton, isAtStart);
    this.updateControlState(this.nextButton, isAtEnd);
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    if (event.currentTarget.getAttribute("aria-disabled") === "true") return;

    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  updateControlState(button, isDisabled) {
    if (button.hasAttribute("data-keep-focusable")) {
      button.removeAttribute("disabled");
      button.setAttribute("aria-disabled", isDisabled ? "true" : "false");
      return;
    }

    button.toggleAttribute("disabled", isDisabled);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    // Define sliderItemsToShow here or ensure it's properly initialized
    this.sliderItemsToShow = this.slider.querySelectorAll(".slideshow__slide");

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();
    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();

    // custom code
    this.extraVisibleElement = 0;
    this.sliderItemsToShow.forEach((ele) => {
      if (this.isElementVisible(ele)) this.extraVisibleElement++;
    });
    if (this.extraVisibleElement != 0) this.extraVisibleElement--;
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this)
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  // custom code
  isElementVisible(element) {
    const rect = element.getBoundingClientRect();
    const rect1 = this.getBoundingClientRect();

    return rect.left >= rect1.left && rect.right <= rect1.right;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide =
      this.currentPage + this.extraVisibleElement ===
      this.sliderItemsToShow.length; // custom code

    if (!isFirstSlide && !isLastSlide) return;
    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    // custom code
    const slideScrollPosition =
      this.currentPage + this.extraVisibleElement === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");

      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            //button.removeAttribute("tabindex");
          });
        //item.setAttribute("aria-hidden", "false");
        //item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            //button.setAttribute("tabindex", "-1");
          });
        //item.setAttribute("aria-hidden", "true");
        //item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

//Custom Slider component
class FPTSliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");

    if (!this.slider) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define("fpt-slider-component", FPTSliderComponent);

class FPTSlideshowComponent extends FPTSliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    // Define sliderItemsToShow here or ensure it's properly initialized
    this.sliderItemsToShow = this.slider.querySelectorAll(".slideshow__slide");

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();
    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();

    // custom code
    this.extraVisibleElement = 0;
    this.sliderItemsToShow.forEach((ele) => {
      if (this.isElementVisible(ele)) this.extraVisibleElement++;
    });
    if (this.extraVisibleElement != 0) this.extraVisibleElement--;
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this)
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  // custom code
  isElementVisible(element) {
    const rect = element.getBoundingClientRect();
    const rect1 = this.getBoundingClientRect();

    return rect.left >= rect1.left && rect.right <= rect1.right;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide =
      this.currentPage + this.extraVisibleElement ===
      this.sliderItemsToShow.length; // custom code

    if (!isFirstSlide && !isLastSlide) return;
    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");

    if (!this.sliderControlButtons.length) return;

    // Keep pagination state synced with the visible slide when multiple cards are visible.
    this.currentPage = this.getNearestSlideIndex() + 1;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
      link.blur();
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
    clearTimeout(this.autoRotateFallbackTimeout);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  getNearestSlideIndex() {
    if (!this.sliderItemsToShow?.length) return 0;

    const currentLeft = this.slider.scrollLeft;
    let nearestIndex = 0;
    let nearestDistance = Number.POSITIVE_INFINITY;

    this.sliderItemsToShow.forEach((slide, index) => {
      const distance = Math.abs(slide.offsetLeft - currentLeft);
      if (distance < nearestDistance) {
        nearestDistance = distance;
        nearestIndex = index;
      }
    });

    return nearestIndex;
  }

  autoRotateSlides() {
    const slideStep = this.sliderItemOffset || this.sliderFirstItemNode?.clientWidth;
    if (!slideStep) return;

    const pageCount =
      this.sliderControlLinksArray?.length ||
      Math.max(this.sliderItemsToShow.length - this.extraVisibleElement, 1);
    const currentPageIndex = Math.min(this.getNearestSlideIndex(), pageCount - 1);
    const nextPageIndex = currentPageIndex + 1 >= pageCount ? 0 : currentPageIndex + 1;

    const slideScrollPosition = nextPageIndex * slideStep;
    const startPosition = this.slider.scrollLeft;

    this.slider.scrollTo({
      left: slideScrollPosition,
    });

    // A layout shift elsewhere on the page can cancel the animated scroll before it
    // completes, which leaves the slide unchanged. Land the position directly when
    // the animated scroll had no effect, then reconcile the pagination and slide
    // state that the scroll listeners would otherwise have refreshed.
    clearTimeout(this.autoRotateFallbackTimeout);
    this.autoRotateFallbackTimeout = setTimeout(() => {
      if (Math.abs(this.slider.scrollLeft - startPosition) >= 1) return;

      this.slider.scrollTo({
        left: slideScrollPosition,
        behavior: "instant",
      });
      this.update();
      this.setSlideVisibility();
    }, 600);
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");

      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const targetSlideIndex = this.sliderControlLinksArray.indexOf(event.currentTarget);
    const slideStep = this.sliderItemOffset || this.sliderFirstItemNode?.clientWidth;
    if (targetSlideIndex < 0 || !slideStep) return;

    const slideScrollPosition = slideStep * targetSlideIndex;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  // observe and response to atribute changes
  static get observedAttributes() {
    return ["data-autoplay"];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "data-autoplay") {
      if (newValue === "true") {
        this.play();
      } else if (newValue === "false") {
        this.pause();
      }
    }
  }
}

customElements.define("fpt-slideshow-component", FPTSlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updateSoldOutBadge();
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantValue();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateCardURL();
      this.updateStockCountdown();
    }
  }
  updateSoldOutBadge() {
    const card = this.closest(".card-wrapper");
    const soldOutBadge = card?.querySelector(".sold-out-badge");

    if (soldOutBadge) {
      const isAvailable = this.currentVariant && this.currentVariant.available;
      soldOutBadge.classList.toggle("hidden", isAvailable);
    }
  }
  updateVariantValue() {
    if (this.dataset.layout == "button") {
      event.target.closest("fieldset").querySelector("legend span").innerHTML =
        event.target.value;
    }
  }
  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }
  updateStockCountdown() {
    if (!this.currentVariant) return;

    if (this.dataset.layout == "card") {
      let card = this.closest(".card");
      if (card && card.querySelector(".wbstockcount") != null) {
        let variantsData = JSON.parse(
          card.querySelector("#card_product-variants").innerHTML
        );
        let stockCountdownConfig = JSON.parse(
          card.querySelector("#card_product-stock-countdown-config").innerHTML
        );
        let variant = this.currentVariant;
        let countdownWrapper = card.querySelector(".wbstockcount");
        if (
          variantsData[variant.id]["q"] > 0 &&
          variant.inventory_management == "shopify"
        ) {
          card.querySelector(".wbstockcount").classList.remove("hidden");
          card.querySelector(".wbstockinfo-bar")?.classList.remove("hidden");
          if (
            variantsData[variant.id]["q"] >
            stockCountdownConfig.limited_stock_cut_off
          ) {
            // High Stock
            countdownWrapper
              .querySelector(".wbstockinfo")
              .classList.remove("wbstockinfo_low", "wbstockinfo_soon");
            countdownWrapper
              .querySelector(".wbstockinfo")
              .classList.add("wbstockinfo_high");
            countdownWrapper.querySelector(".wbstockinfo").innerHTML =
              stockCountdownConfig.instock_message.replace(
                "{stock_number}",
                variantsData[variant.id]["q"]
              );
            if (countdownWrapper.querySelector(".wbstockinfo-probar"))
              countdownWrapper.querySelector(
                ".wbstockinfo-probar"
              ).style.width =
                (variantsData[variant.id]["q"] * 100) /
                  stockCountdownConfig.max_stock +
                "%";
          } else {
            // Low Stock
            countdownWrapper
              .querySelector(".wbstockinfo")
              .classList.replace("wbstockinfo_soon", "wbstockinfo_low");
            countdownWrapper
              .querySelector(".wbstockinfo")
              .classList.add("wbstockinfo_low");
            countdownWrapper.querySelector(".wbstockinfo").innerHTML =
              stockCountdownConfig.limited_stock_message.replace(
                "{stock_number}",
                variantsData[variant.id]["q"]
              );
            if (countdownWrapper.querySelector(".wbstockinfo-probar"))
              countdownWrapper.querySelector(
                ".wbstockinfo-probar"
              ).style.width =
                (variantsData[variant.id]["q"] * 100) /
                  stockCountdownConfig.max_stock +
                "%";
          }
        } else if (variantsData[variant.id]["p"] == "continue") {
          card.querySelector(".wbstockcount").classList.remove("hidden");
          card.querySelector(".wbstockinfo-bar")?.classList.add("hidden");
          countdownWrapper
            .querySelector(".wbstockinfo")
            .classList.remove("wbstockinfo_low", "wbstockinfo_high");
          countdownWrapper
            .querySelector(".wbstockinfo")
            .classList.add("wbstockinfo_soon");
          if (countdownWrapper.querySelector(".wbstockinfo"))
            countdownWrapper.querySelector(".wbstockinfo").innerHTML =
              stockCountdownConfig.continue_selling_message.replace();
        } else {
          card.querySelector(".wbstockcount").classList.add("hidden");
        }
      }
    } else {
      let productMain = this.closest(".product");
      if (productMain && productMain.querySelector(".wbstockcount") != null) {
        let variantsData = JSON.parse(
          productMain.querySelector("#product-variants").innerHTML
        );
        let stockCountdownConfig = JSON.parse(
          productMain.querySelector("#product-stock-countdown-config").innerHTML
        );
        let variant = this.currentVariant;
        let countdownWrapper = productMain.querySelector(".wbstockcount");
        if (
          variantsData[variant.id]["q"] > 0 &&
          variant.inventory_management == "shopify"
        ) {
          productMain.querySelector(".wbstockcount").classList.remove("hidden");
          productMain
            .querySelector(".wbstockinfo-bar")
            .classList.remove("hidden");
          if (
            variantsData[variant.id]["q"] >
            stockCountdownConfig.limited_stock_cut_off
          ) {
            // High Stock
            countdownWrapper
              .querySelector(".wbstockinfo")
              .classList.remove("wbstockinfo_low", "wbstockinfo_soon");
            countdownWrapper
              .querySelector(".wbstockinfo")
              .classList.add("wbstockinfo_high");
            countdownWrapper.querySelector(".wbstockinfo").innerHTML =
              stockCountdownConfig.instock_message.replace(
                "{stock_number}",
                variantsData[variant.id]["q"]
              );
            countdownWrapper.querySelector(".wbstockinfo-probar").style.width =
              (variantsData[variant.id]["q"] * 100) /
                stockCountdownConfig.max_stock +
              "%";
          } else {
            // Low Stock
            countdownWrapper
              .querySelector(".wbstockinfo")
              .classList.replace("wbstockinfo_soon", "wbstockinfo_low");
            countdownWrapper
              .querySelector(".wbstockinfo")
              .classList.add("wbstockinfo_low");
            countdownWrapper.querySelector(".wbstockinfo").innerHTML =
              stockCountdownConfig.limited_stock_message.replace(
                "{stock_number}",
                variantsData[variant.id]["q"]
              );
            countdownWrapper.querySelector(".wbstockinfo-probar").style.width =
              (variantsData[variant.id]["q"] * 100) /
                stockCountdownConfig.max_stock +
              "%";
          }
        } else if (variantsData[variant.id]["p"] == "continue") {
          productMain.querySelector(".wbstockcount").classList.remove("hidden");
          productMain.querySelector(".wbstockinfo-bar").classList.add("hidden");
          countdownWrapper
            .querySelector(".wbstockinfo")
            .classList.remove("wbstockinfo_low", "wbstockinfo_high");
          countdownWrapper
            .querySelector(".wbstockinfo")
            .classList.add("wbstockinfo_soon");
          countdownWrapper.querySelector(".wbstockinfo").innerHTML =
            stockCountdownConfig.continue_selling_message.replace();
        } else {
          productMain.querySelector(".wbstockcount").classList.add("hidden");
        }
      }
    }
  }
  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    // Variant in Product Card
    if (this.dataset.layout == "card") {
      const card = this.closest(".card");
      const newMedia = card.querySelector(
        `[data-media-id="${this.dataset.section}-${this.dataset.product}-${this.currentVariant.featured_media.id}"]`
      );
      if (!newMedia) return;
      const modalContent = card.querySelector(".card__media");
      const newMediaModal = modalContent.querySelector(
        `[data-media-id="${this.currentVariant.featured_media.id}"]`
      );
      const parent = newMedia.parentElement;
      if (parent.firstChild == newMedia) return;
      parent.prepend(newMedia);
      this.stickyHeader =
        this.stickyHeader || document.querySelector("sticky-header");
      if (this.stickyHeader) {
        this.stickyHeader.dispatchEvent(new Event("preventHeaderReveal"));
      }
    } else {
      const mediaGalleries = document.querySelectorAll(
        `[id^="MediaGallery-${this.dataset.section}"]`
      );
      mediaGalleries.forEach((mediaGallery) =>
        mediaGallery.setActiveMedia(
          `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
          true
        )
      );
      const modalContent = document.querySelector(
        `#ProductModal-${this.dataset.section} .product-media-modal__content`
      );
      if (!modalContent) return;
      const newMediaModal = modalContent.querySelector(
        `[data-media-id="${this.currentVariant.featured_media.id}"]`
      );
      modalContent.prepend(newMediaModal);
    }
  }
  updateCardURL() {
    if (this.dataset.layout == "card") {
      const card = this.closest(".card");
      const modalContent = card.querySelector(".card__media");
      const productAnchor = modalContent.querySelector("a");
      const productTitle = card.querySelector(".card__heading");
      const productTitleAnchor = productTitle.querySelector("a");
      const productQuickview = card.querySelector(".js-wbquickview-link");
      let productURL = this.updateURLParameter(
        this.dataset.url,
        "variant",
        this.currentVariant.id
      );
      productAnchor.setAttribute("href", productURL);
      productTitleAnchor.setAttribute("href", productURL);
      if (productQuickview) {
        productQuickview.setAttribute("variant-id", this.currentVariant.id);
      }
    }
  }
  updateURLParameter(url, param, paramVal) {
    var newAdditionalURL = "";
    var tempArray = url.split("?");
    var baseURL = tempArray[0];
    var additionalURL = tempArray[1];
    var temp = "";
    if (additionalURL) {
      tempArray = additionalURL.split("&");
      for (var i = 0; i < tempArray.length; i++) {
        if (tempArray[i].split("=")[0] != param) {
          newAdditionalURL += temp + tempArray[i];
          temp = "&";
        }
      }
    }
    var rows_txt = temp + "" + param + "=" + paramVal;
    return baseURL + "?" + newAdditionalURL + rows_txt;
  }
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    // Variant in Product Card
    if (this.dataset.layout == "card") {
      const card = this.closest(".card");
      const productForms = card.querySelectorAll(
        `#ProductInfo-${this.dataset.section}-${this.dataset.product}`
      );
      productForms.forEach((productForm) => {
        const input = productForm.querySelectorAll('input[name="id"]');
        Array.from(input).forEach((element, index) => {
          element.value = this.currentVariant.id;
        });
        const select = productForm.querySelectorAll('select[name="id"]');
        Array.from(select).forEach((element, index) => {
          element.value = this.currentVariant.id;
        });

        const fieldsets = Array.from(this.querySelectorAll("fieldset"));
        fieldsets.forEach(function (option) {
          Array.from(option.querySelectorAll("label")).find((element) =>
            element.classList.remove("active")
          );
        });
        const optionData =
          this.closest(".grid__item").querySelectorAll("select option");
        const regularPrice = this.closest(".grid__item").querySelector(
          ".price.price__container .price__regular .price-item--regular"
        );
        const saleRegularPrice = this.closest(".grid__item").querySelector(
          ".price.price__container .price__sale .price-item--sale"
        );
        const salePrice = this.closest(".grid__item").querySelector(
          ".price.price__container .price__sale .price-item--regular"
        );
        const wbunitPrice = this.closest(".grid__item").querySelector(
          ".price.price__container .unit-price .cardunitp"
        );
        const wbunitValue = this.closest(".grid__item").querySelector(
          ".price.price__container .unit-price .cardunitv"
        );

        const wbPercentBadge = this.closest(".grid__item").querySelector(
          ".card__badge .percent__badge-sale"
        );
        const wbAmountBadge = this.closest(".grid__item").querySelector(
          ".card__badge .amount__badge-sale"
        );

        optionData.forEach((data) => {
          if (data.value == this.currentVariant.id) {
            if (
              data.dataset.cprice != "" &&
              data.dataset.price != data.dataset.cprice
            ) {
              saleRegularPrice.innerHTML = data.dataset.price;
              salePrice.innerHTML = data.dataset.cprice;
              if (data.dataset.damount != "") {
                wbAmountBadge.innerHTML = data.dataset.damount;
                wbAmountBadge.classList.remove("hidden");
              }
              if (data.dataset.percent != "") {
                wbPercentBadge.innerHTML = data.dataset.percent;
                wbPercentBadge.classList.remove("hidden");
              }
              this.closest(".grid__item")
                .querySelector(".price")
                .classList.add("price--on-sale");
            } else {
              if (regularPrice) {
                regularPrice.innerHTML = data.dataset.price;
              }
              if (wbPercentBadge) {
                wbPercentBadge.classList.add("hidden");
              }
              if (wbAmountBadge) {
                wbAmountBadge.classList.add("hidden");
              }
              this.closest(".grid__item")
                .querySelector(".price")
                .classList.remove("price--on-sale");
            }
            if (data.dataset.unitprice) {
              wbunitPrice.innerHTML = data.dataset.unitprice;
              this.closest(".grid__item")
                .querySelector(".price")
                .classList.add("price--on-sale");
            }
            if (data.dataset.unitvalue) {
              wbunitValue.innerHTML = data.dataset.unitvalue;
              this.closest(".grid__item")
                .querySelector(".price")
                .classList.add("price--on-sale");
            }
          }
        });
      });
      return;
    }

    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product_form_input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value")
        );
      }
    });
  }
  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    let sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    if (this.dataset.layout == "card") {
      fetch(
        `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
          this.dataset.originalSection
            ? this.dataset.originalSection
            : this.dataset.section
        }`
      )
        .then((response) => response.text())
        .then((responseText) => {
          if (this.currentVariant.id !== requestedVariantId) return;
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );

          const oosDisabled = !!html.querySelector('span.oos-disabled[data-oos-disabled="true"]');

          this.toggleAddButton(
            oosDisabled || !this.currentVariant.available,
            window.variantStrings.soldOut
          );
          sectionId = `${sectionId}-${this.dataset.product}`;
          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId,
              html,
              variant: this.currentVariant,
            },
          });
        });
      // this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      return;
    }

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );

        const volumePricingSource = html.getElementById(
          `Volume-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );

        const pricePerItemDestination = document.getElementById(
          `Price-Per-Item-${this.dataset.section}`
        );
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );

        const volumePricingDestination = document.getElementById(
          `Volume-${this.dataset.section}`
        );
        const qtyRules = document.getElementById(
          `Quantity-Rules-${this.dataset.section}`
        );
        const volumeNote = document.getElementById(
          `Volume-Note-${this.dataset.section}`
        );

        if (volumeNote) volumeNote.classList.remove("hidden");
        if (volumePricingDestination)
          volumePricingDestination.classList.remove("hidden");
        if (qtyRules) qtyRules.classList.remove("hidden");

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "visibility-hidden",
            skuSource.classList.contains("visibility-hidden")
          );
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle(
            "visibility-hidden",
            pricePerItemSource.classList.contains("visibility-hidden")
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "visibility-hidden",
            inventorySource.innerText === ""
          );

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`
        );
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    // Variant in Product Card
    var selector = `product-form-${this.dataset.section}`;
    if (this.dataset.layout == "card") {
      selector = `product-form-${this.dataset.section}-${this.dataset.product}`;
    }
    const productForm = document.getElementById(selector);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;
    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }
    if (!modifyClass) return;
  }

  setUnavailable() {
    // Variant in Product Card
    var selector = `product-form-${this.dataset.section}`;
    var priceSelector = `price-${this.dataset.section}`;
    var button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (this.dataset.layout == "card") {
      selector = `product-form-${this.dataset.section}-${this.dataset.product}`;
      priceSelector = `price-${this.dataset.section}-${this.dataset.product}`;
      button = document.getElementById(
        `product-form-${this.dataset.section}-${this.dataset.product}`
      );
    }

    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    // if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

// Webi collaps
class WebiCollapse extends HTMLElement {
  constructor() {
    super();
    const isFooterCollapse = this.classList.contains("footer__blocks-wrapper");
    const shouldForceOpenOnDesktop =
      isFooterCollapse && window.matchMedia("(min-width: 992px)").matches;
    const toggles = this.getElementsByClassName("toggle");
    Array.from(toggles).forEach((toggle, index) => {
      const content = this.getContentElement(toggle);
      const defaultOpen = shouldForceOpenOnDesktop || toggle.classList.contains("active");
      const isButton = toggle.tagName === "BUTTON";

      if (!isButton) {
        toggle.setAttribute("tabindex", "0");
      }

      if (defaultOpen) {
        toggle.classList.add("active");
        toggle.classList.remove("collapsed");
      }

      if (content) {
        if (!content.id) {
          const toggleId = toggle.id || `WebiCollapseToggle-${index}`;
          if (!toggle.id) toggle.id = toggleId;
          content.id = `${toggle.id}-panel`;
        }

        toggle.setAttribute("aria-controls", content.id);
        toggle.setAttribute("aria-expanded", defaultOpen ? "true" : "false");

        if (defaultOpen) {
          content.hidden = false;
          content.style.visibility = "visible";
          content.setAttribute("aria-hidden", "false");
          content.setAttribute("data-collapsed", "false");
        } else {
          content.hidden = true;
          content.style.height = "0px";
          content.style.visibility = "hidden";
          content.setAttribute("aria-hidden", "true");
          content.setAttribute("data-collapsed", "true");
        }
      }

      toggle.addEventListener("click", this.onSectionClick.bind(this));
      toggle.addEventListener("keydown", this.handleKeyDown.bind(this));
    });
  }

  getContentElement(toggle) {
    const controlledId = toggle.getAttribute("aria-controls");
    if (controlledId) {
      const controlled = this.querySelector(`#${controlledId}`);
      if (controlled) {
        return controlled.closest(".wbcollapse_cont") || controlled;
      }
    }

    if (toggle.nextElementSibling) {
      return toggle.nextElementSibling;
    }

    if (toggle.parentElement && toggle.parentElement.nextElementSibling) {
      return toggle.parentElement.nextElementSibling;
    }

    return null;
  }

  handleKeyDown(event) {
    if (event.key === "Enter" || event.key === " " || event.keyCode === 13 || event.keyCode === 32) {
      event.preventDefault();
      this.onSectionClick(event);
    }
  }

  onSectionClick(event) {
    const toggle = event.currentTarget;
    toggle.classList.toggle("active");
    const content = this.getContentElement(toggle);
    if (!content) return;

    const isCollapsed = content.getAttribute("data-collapsed") === "true";
    if (isCollapsed) {
      this.expandSection(content);
      toggle.setAttribute("aria-expanded", "true");
    } else {
      this.collapseSection(content);
      toggle.setAttribute("aria-expanded", "false");
    }
  }

  expandSection(element) {
    element.hidden = false;
    element.style.visibility = "visible";
    element.setAttribute("aria-hidden", "false");

    var sectionHeight = element.scrollHeight;
    element.style.height = sectionHeight + "px";
    element.addEventListener("transitionend", () => {
      element.removeEventListener("transitionend", this.expandSection);
      element.style.height = null;
      element.style.visibility = "visible";
    });
    element.setAttribute("data-collapsed", "false");
  }
  collapseSection(element) {
    var sectionHeight = element.scrollHeight;
    element.style.height = sectionHeight + "px";
    element.offsetHeight;

    element.style.transition = "height 0.3s ease";
    element.style.height = "0px";

    const finalizeCollapse = () => {
      element.style.transition = "";
      element.style.height = "0px";
      element.style.visibility = "hidden";
      element.hidden = true;
    };

    const onTransitionEnd = () => {
      element.removeEventListener("transitionend", onTransitionEnd);
      finalizeCollapse();
    };

    element.addEventListener("transitionend", onTransitionEnd, { once: true });

    // Some accordion layouts may not emit transitionend reliably.
    setTimeout(() => {
      if (element.getAttribute("data-collapsed") === "true" && !element.hidden) {
        finalizeCollapse();
      }
    }, 350);

    element.setAttribute("aria-hidden", "true");
    element.setAttribute("data-collapsed", "true");
  }
}
customElements.define("webi-collapse", WebiCollapse);

// User js
class UserPopup extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.popUpClick.bind(this));
    document.addEventListener("click", this.closePopup.bind(this));
  }
  popUpClick(event) {
    event.stopPropagation();
    this.querySelector("#userdrop").classList.toggle("hidden");
  }
  closePopup(event) {
    const userPopup = this.querySelector("#userdrop");
    if (!userPopup.contains(event.target)) {
      userPopup.classList.add("hidden");
    }
  }
}
customElements.define("user-popup", UserPopup);

// Collection page load more
class LoadMore extends HTMLElement {
  constructor() {
    super();
    this.next_url = document.getElementById("product-grid").dataset.nextUrl;
    this.loadMoreBtn = this.querySelector(".load-more__button");
    if (this.loadMoreBtn) {
      this.loadMoreBtn.addEventListener("click", this.loadMoreProducts.bind(this));
    }
  }
  async getNextPage() {
    try {
      let res = await fetch(this.next_url);
      return await res.text();
    } catch (error) {
      console.log(error);
    }
  }
  async loadMoreProducts() {
    const load_more_spinner =
      this.getElementsByClassName("load-more_spinner")[0];
    if (this.loadMoreBtn) this.loadMoreBtn.style.display = "none";
    load_more_spinner.style.display = "block";
    let nextPage = await this.getNextPage();
    const parser = new DOMParser();
    const nextPageDoc = parser.parseFromString(nextPage, "text/html");
    load_more_spinner.style.display = "none";
    const productgrid = nextPageDoc.getElementById("product-grid");
    const new_products = productgrid.getElementsByClassName("grid__item");
    const new_url = productgrid.dataset.nextUrl;
    let firstInsertedProduct = null;
    if (new_url) {
      if (this.loadMoreBtn) this.loadMoreBtn.style.display = "inline-flex";
    }
    this.next_url = new_url;
    for (let i = 0; i < new_products.length; i++) {
      if (new_products[i].classList.contains("wbimgbnrblock")) continue;
      const insertedItem = new_products[i];
      document.getElementById("product-grid").appendChild(insertedItem);
      if (!firstInsertedProduct) {
        firstInsertedProduct = insertedItem;
      }
    }

    reinitialiseRatingSnippet();

    if (firstInsertedProduct) {
      const focusTarget = firstInsertedProduct.querySelector(
        "a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex='-1'])"
      );

      if (focusTarget) {
        focusTarget.focus();
      } else {
        firstInsertedProduct.setAttribute("tabindex", "-1");
        firstInsertedProduct.focus();
      }
    }
  }
}
customElements.define("load-more", LoadMore);

// on click remove content on video
document.querySelectorAll(".banner-content-remove").forEach((close) => {
  close.addEventListener("click", (event) => {
    const parentElement = event.currentTarget.closest(".video_banner_box");
    if (parentElement) {
      parentElement.remove();
    }
  });
});

// Variant popup
class WBCardVariant extends HTMLElement {
  constructor() {
    super();
    const selectBtn = this.querySelector(".wb_select_btn");
    if (selectBtn)
      selectBtn.addEventListener("click", this.addClassToParent.bind(this));
    document.addEventListener("click", this.onFocusOut.bind(this));
    this.setPopupVariantFocusability(false);
  }
  setPopupVariantFocusability(isEnabled) {
    const popupRadios = this.querySelectorAll(
      ".wb_popup_variant input[type='radio']"
    );

    popupRadios.forEach((radio) => {
      const isUnavailable =
        radio.disabled ||
        radio.classList.contains("disabled") ||
        radio.getAttribute("aria-disabled") === "true";

      if (isEnabled) {
        if (isUnavailable) {
          radio.setAttribute("tabindex", "-1");
          radio.setAttribute("aria-hidden", "true");
          return;
        }

        // Keep each enabled option as a direct tab stop in the opened popup.
        radio.setAttribute("tabindex", "0");
        radio.removeAttribute("aria-hidden");
      } else {
        radio.setAttribute("tabindex", "-1");
        radio.setAttribute("aria-hidden", "true");
      }
    });
  }
  onFocusOut(event) {
    event.stopPropagation();
    if (this.contains(event.target)) return;
    const ele = this.querySelector(".parent-selected");
    if (ele) {
      ele.classList.remove("parent-selected");
      ele.style = "";
      this.setPopupVariantFocusability(false);
    }
  }
  addClassToParent(event) {
    const wbparentElement = this.querySelector(".wbproductdes");
    const beforeinfo = wbparentElement.getBoundingClientRect().height;
    wbparentElement.classList.add("parent-selected");
    const afterinfo = wbparentElement.getBoundingClientRect().height;
    wbparentElement.style =
      "margin-top: " + (beforeinfo - afterinfo).toString() + "px;";
    this.setPopupVariantFocusability(true);
  }
}
customElements.define("wb-card-variant", WBCardVariant);

// Verticle menu
class DesktopWebiMenu extends HTMLElement {
  constructor() {
    super();
    const drop = this.dataset.drop ? this.dataset.drop : "click";
    document.addEventListener("click", this.onFocusOut.bind(this));
    this.addEventListener("keydown", this.handleKeyDown.bind(this));
    this.querySelectorAll("li").forEach((ele) => {
      ele.addEventListener("keydown", this.handleLiKeyDown.bind(this));
      ele.addEventListener(drop, () => {
        this.onLiClick(ele);
      });
      if (drop == "mouseover") {
        ele.addEventListener("mouseout", () => {
          this.closeLi();
        });
      }
    });
  }
  handleLiKeyDown(event) {
    if (event.keyCode === 13) {
      if (event.target.classList.contains("menuclick"))
        event.target.classList.remove("menuclick");
      else this.onLiClick(event.target);
    }
  }
  handleKeyDown(event) {
    if (event.keyCode === 13) {
      this.onFocusOut(event);
    }
  }
  onLiClick(ele) {
    this.closeLi();
    ele.classList.add("menuclick");
  }
  closeLi() {
    this.querySelectorAll("li.menuclick").forEach((ele) => {
      ele.classList.remove("menuclick");
    });
  }
  onFocusOut(event) {
    event.stopPropagation();
    if (
      this.contains(event.target) &&
      !this.querySelector("#menu-drawer").contains(event.target)
    ) {
      if (this.classList.contains("open")) {
        this.classList.remove("open");
        this.closeLi();
      } else this.classList.add("open");
    } else if (!this.querySelector("#menu-drawer").contains(event.target)) {
      this.classList.remove("open");
      this.closeLi();
    }
  }
}
customElements.define("desktop-webi-menu", DesktopWebiMenu);

// Blog left sidebar Drawer Javascript
class ArticleToggle extends HTMLElement {
  constructor() {
    super();
    this.sidebar = this.querySelector(".sidebar");
    this.toggleButton = this.querySelector(".toggle-button");
    this.closeBtn = this.querySelector(".sidebar-close");
    this.toggleButton.addEventListener("click", this.toggleSidebar.bind(this));
    this.closeBtn.addEventListener("click", this.closeSidebar.bind(this));
  }
  toggleSidebar() {
    this.sidebar.classList.add("active");
    document.body.classList.add("overflow-hidden");
  }
  closeSidebar() {
    this.sidebar.classList.remove("active");
    document.body.classList.remove("overflow-hidden");
  }
}
customElements.define("article-toggle", ArticleToggle);

// counter section
class Counter extends HTMLElement {
  constructor() {
    super();
    this.section_counter = this.querySelector("#section_counter");
    this.counters = this.querySelectorAll(".counter-item .scroll_count");
    this.CounterObserver = new IntersectionObserver(
      (entries) => {
        if (!entries.some((v) => v.isIntersecting)) {
          this.counters.forEach((counter) => {
            const counterNumber = +counter.innerText;
            if (counterNumber === 0) return;
            counter.innerText = "0";
          });
          return;
        }
        let speed = 100;
        this.counters.forEach((counter, index) => {
          const targetText = counter.dataset.target;

          if (!/^\d+$/.test(targetText)) {
            counter.innerText = targetText;
            return;
          }

          const targetNumber = parseFloat(targetText);
          const increment = targetNumber / speed;
          let currentNumber = 0;

          function UpdateCounter() {
            if (currentNumber < targetNumber) {
              currentNumber = Math.min(currentNumber + increment, targetNumber);
              counter.innerText =
                currentNumber > 999999
                  ? `${Math.floor(currentNumber / 1000000)}M+`
                  : currentNumber > 9999
                  ? `${Math.floor(currentNumber / 1000)}k+`
                  : currentNumber >= 1000
                  ? Math.ceil(currentNumber).toLocaleString("en-US")
                  : Math.ceil(currentNumber);
              requestAnimationFrame(UpdateCounter);
            } else {
              counter.innerText =
                targetNumber > 999999
                  ? `${Math.floor(targetNumber / 1000000)}M+`
                  : targetNumber > 9999
                  ? `${Math.floor(targetNumber / 1000)}k+`
                  : targetNumber >= 1000
                  ? targetNumber.toLocaleString("en-US")
                  : targetNumber;
            }
          }

          UpdateCounter();
          if (counter.parentElement.style.animation) {
            counter.parentElement.style.animation = "";
          } else {
            counter.parentElement.style.animation = `slide-up 0.3s ease forwards ${
              index / this.counters.length + 0.5
            }s`;
          }
        });
      },
      {
        root: null,
        threshold: window.innerWidth > 768 ? 0.4 : 0.3,
      }
    );
    this.CounterObserver.observe(this.section_counter);
  }
}

customElements.define("c-counter", Counter);

// counter v2 section
class ImageWithTextV2 extends HTMLElement {
  constructor() {
    super();
    this.sectionImageWithTextCounter = this.querySelector(
      "#section_image-with-text-v2"
    );
    this.counters = this.querySelectorAll(".image-with-text-v2__number");

    this.CounterObserver = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) {
          this.counters.forEach((counter) => {
            const counterNumber = +counter.innerText;
            if (counterNumber === 0) return;
            counter.innerText = "0";
          });
          return;
        }

        let speed = 100;
        this.counters.forEach((counter, index) => {
          const targetText = counter.dataset.target || counter.innerText.trim();

          if (!/^\d+$/.test(targetText)) {
            counter.innerText = targetText;
            return;
          }

          const targetNumber = parseFloat(targetText);
          const increment = targetNumber / speed;
          let currentNumber = 0;

          function updateCounter() {
            if (currentNumber < targetNumber) {
              currentNumber = Math.min(currentNumber + increment, targetNumber);
              counter.innerText =
                currentNumber > 999999
                  ? `${Math.floor(currentNumber / 1000000)}M+`
                  : currentNumber > 9999
                  ? `${Math.floor(currentNumber / 1000)}k+`
                  : currentNumber >= 1000
                  ? Math.ceil(currentNumber).toLocaleString("en-US")
                  : Math.ceil(currentNumber);
              requestAnimationFrame(updateCounter);
            } else {
              counter.innerText =
                targetNumber > 999999
                  ? `${Math.floor(targetNumber / 1000000)}M+`
                  : targetNumber > 9999
                  ? `${Math.floor(targetNumber / 1000)}k+`
                  : targetNumber >= 1000
                  ? targetNumber.toLocaleString("en-US")
                  : targetNumber;
            }
          }

          updateCounter();
          if (counter.parentElement.style.animation) {
            counter.parentElement.style.animation = "";
          } else {
            counter.parentElement.style.animation = `slide-up 0.3s ease forwards ${
              index / this.counters.length + 0.5
            }s`;
          }
        });
      },
      {
        root: null,
        threshold: window.innerWidth > 768 ? 0.4 : 0.3,
      }
    );

    if (this.sectionImageWithTextCounter) {
      this.CounterObserver.observe(this.sectionImageWithTextCounter);
    }
  }
}

customElements.define("image-with-text-v2", ImageWithTextV2);

// Variant hover
class VariantHover extends VariantSelects {
  constructor() {
    super();
    const fieldsets = Array.from(this.querySelectorAll("fieldset label"));
    this.querySelectorAll("fieldset label").forEach((ele) => {
      ele.addEventListener("mouseenter", this.onVariantChangeHover.bind(this));
      ele.addEventListener("click", this.onLabelClick.bind(this));
    });
  }

  onLabelClick(event) {
    if (event.target.dataset.href) {
      window.location.href = event.target.dataset.href;
    }
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions(ele) {
    if (
      ele.attributes.for &&
      this.querySelector("#" + ele.attributes.for.value)
    ) {
      this.querySelector("#" + ele.attributes.for.value).checked = true;
    }
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }

  updatelabelDataset(ele) {
    let href = ele.dataset.href;
    if (href.indexOf("?variant=") > -1) {
      href =
        href.substring(0, href.indexOf("?variant=") + 9) +
        this.currentVariant.id;
    } else {
      href += "?variant=" + this.currentVariant.id;
    }
    ele.dataset.href = href;
  }

  onVariantChangeHover(event) {
    this.updateOptions(event.target);
    this.updateMasterId();
    this.updatelabelDataset(event.target);
    this.updateMedia();
  }

  onVariantChange() {
    // Don't dlt it
  }
}

customElements.define("variant-hover", VariantHover);


// Tooltip Logic
(function () {

  let attempts = 0;
  const MAX_ATTEMPTS = 10;
  const INTERVAL = 1000;

  const intervalId = setInterval(() => {
    attempts++;

    const tooltips = document.querySelectorAll('.tooltip');

    if (tooltips.length > 0) {
      clearInterval(intervalId);

      setTimeout(() => {
        const SIDE_SPACING = 10;
        const TOOLTIP_WIDTH = 200;

        tooltips.forEach(tooltip => {
          const tipText = (tooltip.getAttribute('data-tip') || '').trim();

          if (tipText && !tooltip.hasAttribute('aria-label')) {
            tooltip.setAttribute('aria-label', tipText);
          }

          if (!tooltip.hasAttribute('tabindex')) {
            tooltip.setAttribute('tabindex', '0');
          }

          if (!tooltip.dataset.a11yTooltipBound) {
            tooltip.dataset.a11yTooltipBound = 'true';

            tooltip.addEventListener('focus', () => {
              tooltip.classList.add('is-tooltip-visible');
            });

            tooltip.addEventListener('blur', () => {
              tooltip.classList.remove('is-tooltip-visible');
            });

            tooltip.addEventListener('mouseenter', () => {
              tooltip.classList.add('is-tooltip-visible');
            });

            tooltip.addEventListener('mouseleave', () => {
              tooltip.classList.remove('is-tooltip-visible');
            });

            tooltip.addEventListener('keydown', (event) => {
              if (event.key === 'Escape') {
                tooltip.classList.remove('is-tooltip-visible');
              }
            });
          }

          const rect = tooltip.getBoundingClientRect();
          const tooltipLeft = Math.round(rect.left);
          const tooltipEnd = tooltipLeft + TOOLTIP_WIDTH;
          const tooltipBleed = tooltipEnd - window.innerWidth + SIDE_SPACING;

          if ([...tooltip.classList].includes('right') & tooltipEnd > window.innerWidth) {
            tooltip.style.setProperty(
              '--tooltip-right-adjustment',
              `-${tooltipBleed}px`,
              'important'
            );
          }
        });
      }, 1000);
    }

    if (attempts >= MAX_ATTEMPTS) {
      clearInterval(intervalId);
    }

  }, INTERVAL);

})();

  // Rebuy bundle builder cart refresh
(function () {
  let attempts = 0;

  const interval = setInterval(() => {
    const element = document.querySelector(
      '.rebuy-bundle-builder__group-container-action button'
    );

    if (element) {
      clearInterval(interval);
      element.addEventListener('click', () => {
        setTimeout(() => {
          window.location.reload();
        }, 2500);
      });
    }

    attempts++;

    if (attempts > 50) {
      clearInterval(interval);
    }

  }, 200);
})();

// Rebuy Order Forms cart refresh
(function () {
  let attempts = 0;
  const interval = setInterval(() => {

    document.addEventListener('click', (event) => {
      const rebuyButton = event.target.closest('.rebuy-button');

      if (rebuyButton && rebuyButton.closest('.rebuyOrderForms')) {
        setTimeout(() => {
          window.location.reload();
        }, 2500);
      }
    });

    attempts++;

    if (attempts > 50) {
      clearInterval(interval);
    }

  }, 200);

})();


// Tabs
document.addEventListener('DOMContentLoaded', () => {
  const tabGroups = document.querySelectorAll('.tabs');

  tabGroups.forEach(group => {
    const tabs = group.querySelectorAll('[role="tab"]');
    const panels = group.querySelectorAll('[role="tabpanel"]');

    function activateTab(tab) {
      tabs.forEach(t => {
        t.setAttribute('aria-selected', 'false');
        t.setAttribute('tabindex', '-1');
      });

      panels.forEach(p => {
        p.hidden = true;
      });

      tab.setAttribute('aria-selected', 'true');
      tab.setAttribute('tabindex', '0');

      const panel = group.querySelector(
        `#${tab.getAttribute('aria-controls')}`
      );

      if (panel) {
        panel.hidden = false;
      }
    }

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        activateTab(tab);
      });

      tab.addEventListener('keydown', (e) => {
        let newIndex = index;

        if (e.key === 'ArrowRight') {
          newIndex = (index + 1) % tabs.length;
          tabs[newIndex].focus();
        }

        if (e.key === 'ArrowLeft') {
          newIndex = (index - 1 + tabs.length) % tabs.length;
          tabs[newIndex].focus();
        }

        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          activateTab(tab);
        }
      });
    });
  });
});
